import {Box, BoxProps, Heading} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

interface Props extends BoxProps {
  title?: string;
}

export const TitledSection: FC<Props> = ({title, children, ...boxProps}) => {
  return (
    <Box w="100%" {...boxProps}>
      <Heading as="h3" fontSize="18px" fontWeight="700" color={colors.textGray} mb="15px">
        {title}
      </Heading>
      {children}
    </Box>
  );
};
